var map = {
	"./frame-creative.png": 1995,
	"./frame-img.png": 1996,
	"./frame-math.png": 1997,
	"./frame-pyt-nosnake.png": 1998,
	"./frame-pyt.png": 1999,
	"./frame.svg": 2000,
	"./start-bg.png": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1994;